import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getClientHistory } from '../../../../redux/slices/clientSlice'
import { defaultUserImg } from '../../../../helper/imagepath'
import {
  checkIfPastDate,
  convertTimestampToDate,
  convertTimestampToTime,
  getBookingStatusClass,
  getUserRole,
  hasAccess
} from '../../../../helper/function'
import { getSchedulePropertyDataById } from '../../../../redux/slices/propertySlice'
import { SpinnerContext } from '../../../../context/spinnerContext'
import BadIcon from '../../../../assets/img/svg/bad-icon.svg'
import ShawerIcon from '../../../../assets/img/svg/shawer-icon.svg'
import ScheduledModalContent from '../../../../component/scheduleStatus/scheduledModalContent'
import CancelModalContent from '../../../../component/scheduleStatus/canceleModalContent'
import StatusModal from '../../../../component/modal/statusModal'
import Pagination from '../../../../component/common/pagination'
const ViewPropertyHistory = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { property_id } = useParams()
  const { changeLoader } = useContext(SpinnerContext)
  const { clientHistoryData } = useSelector((state) => state.client)
  const { scheduledProperties } = useSelector((state) => state.property)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [modalName, setModalName] = useState(null)
  const [chatUserId, setChatUserId] = useState(null)
  const [loader, setLoader] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [itemsPerPage, setItemsPerPage] = useState(6)
  const [currentPage, setCurrentPage] = useState(clientHistoryData?.currentPage || 1)

  const [refresh, setIsRefresh] = useState(false)
  useEffect(() => {
    changeLoader(true)
    setLoader(true)
    const params = {
      params: {
        page: currentPage,
        limit: itemsPerPage || 6
      },
      id: property_id
    }

    dispatch(getClientHistory(params))
      .then(() => {
        setLoader(false)
        changeLoader(false)
        setIsRefresh(false)
      })
      .catch(() => {
        setLoader(false)
        changeLoader(false)
        setIsRefresh(false)
      })
  }, [property_id, currentPage, itemsPerPage, refresh])

  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData]
  )

  const onHandleDetails = useCallback(
    (data) => {
      const { booking_status, property_schedule_id } = data
      setChatUserId(property_schedule_id)
      if (['scheduled', 'canceled', 'in progress', 'canceled cleaner']?.includes(booking_status)) {
        getPropertyData(property_schedule_id, booking_status)
      } else if (['completed']?.includes(booking_status)) {
        navigate(`/${`overview`}/complete-cleaning/${property_schedule_id}/cleaningDetail`)
      }
    },
    [navigate]
  )

  const getPropertyData = async (schedule_id, status) => {
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const overFun = useMemo(() => {
    return scheduledProperties?.getPropertyScheduleData?.next_checkin_time
      ? checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.next_checkin_time, false)
      : checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.booking_date_time, true)
  }, [scheduledProperties?.getPropertyScheduleData])

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1)
  }

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <h5 className="sec_title_text d-flex align-items-center mb-3" onClick={() => navigate(-1)}>
          <i className="fa fa-angle-left fs-5 me-2" aria-hidden="true"></i>
          Schedule Cleanings
        </h5>
        <div className="row">
          {clientHistoryData?.propertySchedules?.length > 0
            ? clientHistoryData?.propertySchedules?.map((cleaningItem, index) => (
                <div className="col-md-12 col-lg-6 col-xl-6" key={index}>
                  <div className="common_card_div upcoming_cleanings_space_div">
                    <div className="upcoming_cleanings_box_div">
                      <div className="upcoming_cleanings_inner_box upcoming_cleanings_flex_div mb-2">
                        <div className="user_img_div">
                          <div className="cleanings_img_div">
                            <img className="img-fluid" src={defaultUserImg} alt="Image" />
                          </div>
                          <div className="user_right_contains">
                            <h6 className="mb-0">
                              {cleaningItem?.cleaners
                                ? `${cleaningItem?.cleaners?.first_name} ${cleaningItem?.cleaners?.last_name}`
                                : 'No Cleaner Yet'}
                            </h6>
                            <div>
                              <span
                                className={
                                  cleaningItem?.scheduleCleaners
                                    ? cleaningItem?.scheduleCleaners?.is_accepted
                                      ? 'accepted_text'
                                      : 'declined_text'
                                    : 'pennding_text'
                                }
                              >
                                {cleaningItem?.scheduleCleaners ? (cleaningItem?.scheduleCleaners?.is_accepted ? 'Accepted' : 'Declined') : 'Pending'}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="show_box show_bg" onClick={() => onHandleDetails(cleaningItem)}>
                          <p>Details</p>
                        </div>
                      </div>
                      <div className="upcoming_cleanings_flex_div mb-2">
                        <p className="fs-14 gray_color fw-400">
                          {cleaningItem?.properties?.address} - {cleaningItem?.properties?.city?.city}
                        </p>
                        <div className={`show_box ${getBookingStatusClass(cleaningItem?.booking_status)}`}>
                          <p>{cleaningItem?.booking_status}</p>
                        </div>
                      </div>
                      <div className="upcoming_cleanings_flex_div mb-2">
                        <div className="amount_div">
                          {hasAccess('accessFinalAmount', getUserRole()) && (
                            <p className="fs-14 black_color fw-400 me-3">${cleaningItem?.finalAmount}</p>
                          )}
                          <label className="cleanings_icon_box_div">
                            <img className="img-fluid" src={ShawerIcon} alt="Image" />
                            {cleaningItem?.properties?.number_of_bathroom}
                          </label>
                          <label className="cleanings_icon_box_div">
                            <img className="img-fluid" src={BadIcon} alt="Image" />
                            {cleaningItem?.properties?.number_of_rooms}
                          </label>
                        </div>
                      </div>
                      <div className="upcoming_cleanings_flex_div">
                        <p className="fs-14 dark_blue_color fw-400">
                          <span>{convertTimestampToDate(cleaningItem?.booking_date_time)}</span> |{' '}
                          <span>{convertTimestampToTime(cleaningItem?.booking_date_time)}</span>
                        </p>
                        <div className="">
                          <p className="fs-16 black_color fw-500">#{cleaningItem?.schedule_number}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : !loader && (
                <div className="common_card_div upcoming_cleanings_space_div">
                  <p style={{ textAlign: 'center' }}>No Data Found</p>
                </div>
              )}
        </div>
        {clientHistoryData?.totalRecords > 0 && (
          <Pagination
            currentPage={currentPage}
            onPageChange={handlePageChange}
            totalPages={clientHistoryData?.totalPage || 0}
            itemsPerPage={itemsPerPage}
          />
        )}
      </div>
      {isStatusModalOpen && (
        <StatusModal
          onClose={() => setIsStatusModalOpen(false)}
          title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
          headerContent={{
            name: clientName,
            status: scheduledProperties?.getPropertyScheduleData?.booking_status
          }}
          chatUserId={chatUserId}
          CheckTimeOver={overFun}
          clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
        >
          {['canceled', 'canceled cleaner']?.includes(modalName) && (
            <CancelModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              finalAmount={scheduledProperties?.finalAmount}
              onClose={() => setIsStatusModalOpen(false)}
            />
          )}
          {['scheduled', 'in progress']?.includes(modalName) && (
            <ScheduledModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              onClose={() => setIsStatusModalOpen(false)}
              page={`view-logs`}
              setIsRefresh={setIsRefresh}
            />
          )}
        </StatusModal>
      )}
    </div>
  )
}
export default ViewPropertyHistory
